/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Box, Button, Divider, Typography } from "@mui/material";
import React, { useEffect, useState, useRef, useCallback } from "react";
import styles from "./AmarantComponent.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { listVignettes } from "../../actions/amarantFields";
import { connect } from "react-redux";
import moment from "moment";
import { filterByProp } from "../../utils/helperFunctions";
import {
  getBaseCurrencyBySwitchDate,
  getDisplayCurrencyOrderBySwitchDate,
  getDualAmountsFromBase,
  formatMoney,
  getCurrencySymbol,
  toNumberOrNull,
} from "../../utils/currency";

const columnNames = [
  "amarant:colPlate",
  "amarant:colPurchaseDate",
  "amarant:colPurchaseTime",
  "amarant:colKind",
  "amarant:colAmount",
  "amarant:colStartDate",
  "amarant:colStatus",
  "amarant:colActivationDate",
  "amarant:colActivated",
];

function VignettesComponent({ vignettes, listVignettes, customerID }) {
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  const now = new Date();
  const baseCurrency = getBaseCurrencyBySwitchDate(now);
  const displayOrder = getDisplayCurrencyOrderBySwitchDate(now);

  const renderAmount = (amount) => {
    const dual = getDualAmountsFromBase(amount, baseCurrency);
    const primary = displayOrder[0];
    const secondary = displayOrder[1];
    const primaryAmount = dual?.[primary];
    const secondaryAmount = dual?.[secondary];

    if (toNumberOrNull(primaryAmount) === null) return "-";

    return (
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
        <b>{`${formatMoney(primaryAmount)} ${getCurrencySymbol(primary)}`}</b>
        {toNumberOrNull(secondaryAmount) !== null && (
          <Typography variant="caption" color="text.secondary">
            {`≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(secondary)}`}
          </Typography>
        )}
      </Box>
    );
  };

  const getPriceBgnNumber = (vig) => {
    const dual = getDualAmountsFromBase(vig?.price, baseCurrency);
    const bgn = dual?.BGN;
    const bgnNum = toNumberOrNull(bgn);
    return bgnNum === null ? null : Math.round(bgnNum);
  };

  useEffect(() => {
    listVignettes({
      customerSupportId: customerID,
      //customerSupportId: "6231bc7bc8696d0016d4af13",
    });
  }, []);

  const handleValid = (vig) => {
    const priceBgn = getPriceBgnNumber(vig);
    switch (priceBgn) {
      case 9:
      case 10:
        return moment().isAfter(
          moment(vig?.purchaseRequest?.saleRows?.[0]?.activationDate).add(
            1,
            "D"
          )
        )
          ? t("amarant:vExpired")
          : t("amarant:vValid");
      case 13:
      case 15:
        return moment().isAfter(
          moment(vig?.purchaseRequest?.saleRows?.[0]?.activationDate).add(
            1,
            "W"
          )
        )
          ? t("amarant:vExpired")
          : t("amarant:vValid");
      case 27:
      case 30:
        return moment().isAfter(
          moment(vig?.purchaseRequest?.saleRows?.[0]?.activationDate).add(
            1,
            "M"
          )
        )
          ? t("amarant:vExpired")
          : t("amarant:vValid");
      case 48:
      case 54:
        return moment().isAfter(
          moment(vig?.purchaseRequest?.saleRows?.[0]?.activationDate).add(
            3,
            "M"
          )
        )
          ? t("amarant:vExpired")
          : t("amarant:vValid");
      case 87:
      case 97:
        return moment().isAfter(
          moment(vig?.purchaseRequest?.saleRows?.[0]?.activationDate).add(
            1,
            "Y"
          )
        )
          ? t("amarant:vExpired")
          : t("amarant:vValid");
      default:
        break;
    }
  };

  return (
    <div
      style={{
        overflowY: "auto",
        height: window.innerWidth < 900 ? "120%" : "95%",
        width: "100%",
      }}
    >
      {window.innerWidth < 900 ? (
        <React.Fragment>
          <div className={styles["tabs-container"]} style={{ padding: "0px" }}>
            {vignettes.map((vignette, i) => {
              return (
                <div
                  className={styles["row-container"]}
                  style={{
                    marginTop: "5%",
                    display: "block",
                    height: "unset",
                  }}
                  key={i}
                >
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[0])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {vignette?.licensePlate}
                    </b>
                  </div>
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[1])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(vignette?.createdAt).format("DD.MM.YYYY")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[2])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(vignette?.createdAt).format("HH:mm")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[3])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {getPriceBgnNumber(vignette) === 10 ||
                      getPriceBgnNumber(vignette) === 9
                        ? t("amarant:vWeekend")
                        : getPriceBgnNumber(vignette) === 15 ||
                          getPriceBgnNumber(vignette) === 13
                        ? t("amarant:vWeekly")
                        : getPriceBgnNumber(vignette) === 30 ||
                          getPriceBgnNumber(vignette) === 27
                        ? t("amarant:vMonthly")
                        : getPriceBgnNumber(vignette) === 54 ||
                          getPriceBgnNumber(vignette) === 48
                        ? t("amarant:vQuarterly")
                        : getPriceBgnNumber(vignette) === 97 ||
                          getPriceBgnNumber(vignette) === 87
                        ? t("amarant:vYearly")
                        : ""}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[4])}
                    </p>
                    <div style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {renderAmount(vignette?.price)}
                    </div>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[5])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {moment(
                        vignette?.purchaseRequest?.saleRows?.[0]?.activationDate
                      ).format("DD.MM.YYYY")}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[6])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {handleValid(vignette)}
                    </b>
                  </div>
                  <Divider />
                  <div className={styles["mobile-box"]}>
                    <p style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {t(columnNames[8])}
                    </p>
                    <b style={{ marginBottom: "1%", fontSize: "14px" }}>
                      {!vignette?.newApp
                        ? t("yes")
                        : vignette?.activationDate
                        ? t("yes")
                        : t("no")}
                    </b>
                  </div>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      ) : (
        <>
          <div className={styles["columns-container"]}>
            <div className={styles["upper-names"]}>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "plate") {
                    setFilter("reversePlate");
                    filterByProp(vignettes, "reversePlate", "licensePlate");
                  } else {
                    setFilter("plate");
                    filterByProp(vignettes, "plate", "licensePlate");
                  }
                }}
              >
                <p>{t(columnNames[0])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {}}
              >
                <p>{t(columnNames[6])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "11%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "buyDate") {
                    setFilter("reverseBuyDate");
                    filterByProp(vignettes, "reverseCreatedAt", "createdAt");
                  } else {
                    setFilter("buyDate");
                    filterByProp(vignettes, "createdAt", "createdAt");
                  }
                }}
              >
                <p>{t(columnNames[1])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "11%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "buyTime") {
                    setFilter("reverseBuyTime");
                    vignettes.sort((a, b) => {
                      var c = moment(a.createdAt).format("HH:mm");
                      var d = moment(b.createdAt).format("HH:mm");
                      if (!c && !d) {
                        return 0;
                      } else if (c && !d) {
                        return 1;
                      } else if (!c && d) {
                        return -1;
                      } else {
                        const value1 = c.toString().toUpperCase();
                        const value2 = d.toString().toUpperCase();
                        if (value1 < value2) {
                          return 1;
                        } else if (value1 > value2) {
                          return -1;
                        } else {
                          return 0;
                        }
                      }
                    });
                  } else {
                    vignettes.sort((a, b) => {
                      var c = moment(a.createdAt).format("HH:mm");
                      var d = moment(b.createdAt).format("HH:mm");
                      if (!c && !d) {
                        return 0;
                      } else if (c && !d) {
                        return -1;
                      } else if (!c && d) {
                        return 1;
                      } else {
                        const value1 = c.toString().toUpperCase();
                        const value2 = d.toString().toUpperCase();
                        if (value1 < value2) {
                          return -1;
                        } else if (value1 > value2) {
                          return 1;
                        } else {
                          return 0;
                        }
                      }
                    });
                    setFilter("buyTime");
                  }
                }}
              >
                <p>{t(columnNames[2])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "11%", cursor: "pointer" }}
                onClick={() => {}}
              >
                <p>{t(columnNames[7])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "type") {
                    setFilter("reverseType");
                    filterByProp(vignettes, "reversePrice", "price");
                  } else {
                    setFilter("type");
                    filterByProp(vignettes, "price", "price");
                  }
                }}
              >
                <p>{t(columnNames[3])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "price") {
                    setFilter("reversePrice");
                    filterByProp(vignettes, "reversePrice", "price");
                  } else {
                    setFilter("price");
                    filterByProp(vignettes, "price", "price");
                  }
                }}
              >
                <p>{t(columnNames[4])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "8%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "buyDate2") {
                    setFilter("reverseBuyDate");
                    filterByProp(vignettes, "reverseCreatedAt", "createdAt");
                  } else {
                    setFilter("buyDate2");
                    filterByProp(vignettes, "createdAt", "createdAt");
                  }
                }}
              >
                <p>{t(columnNames[5])}</p>
              </div>
              <div
                className={`${styles["name-icon"]}`}
                style={{ width: "12%", cursor: "pointer" }}
                onClick={() => {
                  if (filter === "activated") {
                    setFilter("reverseActivated");
                    filterByProp(vignettes, "reverseCreatedAt", "createdAt");
                  } else {
                    setFilter("activated");
                    filterByProp(vignettes, "activated", null);
                  }
                }}
              >
                <p>{t(columnNames[8])}</p>
              </div>
            </div>
          </div>
          <div
            className={styles["tabs-container"]}
            style={{ overfloxY: "auto" }}
          >
            {vignettes.map((vignette, i) => {
              return (
                <div
                  className={styles["row-container"]}
                  style={{ width: "100%", minHeight: "50px", height: "auto" }}
                  key={i}
                >
                  <div className={styles["data"]}>
                    <b>{vignette?.licensePlate || t("amarant:deletedVehicle")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "8%" }}>
                    <b>{handleValid(vignette)}</b>
                  </div>

                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "11%" }}>
                    <b>{moment(vignette?.createdAt).format("DD.MM.YYYY")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "11%" }}>
                    <b>{moment(vignette?.createdAt).format("HH:mm")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]} style={{ width: "11%" }}>
                    <b>
                      {moment(
                        vignette?.purchaseRequest?.saleRows?.[0]?.activationDate
                      ).format("DD.MM.YYYY")}
                    </b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]}>
                    <b>
                      {getPriceBgnNumber(vignette) === 10 ||
                      getPriceBgnNumber(vignette) === 9
                        ? t("amarant:vWeekend")
                        : getPriceBgnNumber(vignette) === 15 ||
                          getPriceBgnNumber(vignette) === 13
                        ? t("amarant:vWeekly")
                        : getPriceBgnNumber(vignette) === 30 ||
                          getPriceBgnNumber(vignette) === 27
                        ? t("amarant:vMonthly")
                        : getPriceBgnNumber(vignette) === 54 ||
                          getPriceBgnNumber(vignette) === 48
                        ? t("amarant:vQuarterly")
                        : getPriceBgnNumber(vignette) === 97 ||
                          getPriceBgnNumber(vignette) === 87
                        ? t("amarant:vYearly")
                        : ""}
                    </b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]}>{renderAmount(vignette?.price)}</div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]}>
                    <b>{moment(vignette?.createdAt).format("DD.MM.YYYY")}</b>
                  </div>
                  <Divider
                    style={{
                      backgroundColor: "#D3D3D3",
                      height: "65%",
                    }}
                    orientation="vertical"
                  />
                  <div className={styles["data"]}>
                    <b>
                      {!vignette?.newApp
                        ? t("yes")
                        : vignette?.activationDate
                        ? t("yes")
                        : t("no")}
                    </b>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  vignettes: state.amarantFields.vignettes,
});

const mapDispatchToProps = (dispatch) => ({
  listVignettes: (payload) => dispatch(listVignettes(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VignettesComponent);
